export default __webpack_public_path__ + "static/media/laGarela.25e31bf0.jpg";